import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listDependenciesAction, editDependenciesAction, deleteDependenciesAction } from '../../../actions/dependenciesActions';
import { Spinner } from 'react-bootstrap';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
//Función principal
const DependencyList = props => {
    const params = {
        sort: 'descripcion:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const dependenciesLoading = useSelector( state => state.dependencies.loading );
    const dependencies = useSelector( state => state.dependencies.dependencies );
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ data, setData ] = useState(null);
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editDependenciesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteDependenciesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {
            name: 'Tipo',
            width: null,
            style: 'text-center',
            field: 'tipo',
            subfield: 'descripcion'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(dependencies){
            //Seteo los datos
            setData(dependencies);
        }else{
            //Si no hay datos, debo cargarlo
            dispatch( listDependenciesAction(params) );
        }
    }, [dependencies]);
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={dependencies}
                            headers={headers}
                            setData={setData}
                        />
                        {
                            dependenciesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            data ? (
                                <TableList
                                    prefix="dp"
                                    headers={headers}
                                    items={data}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DependencyList;